import {AccountInfo} from "./AccountInfo";
import {VideoPokerInfoForClient} from "./VideoPokerInfoForClient";

export class ServerResponse {

    constructor(public accountInfo: AccountInfo,
                public videoPokerInfoForClient: VideoPokerInfoForClient,
                public sessionParam: number) {

    }
}



// WEBPACK FOOTER //
// ./src/app/api/serverResponseClasses/ServerResponse.ts